import { login, logout } from '@/api/login'
import { Auth } from '@/core/utils/auth'

const user = {
  state: {
    token: Auth.getToken(),
    payload: Auth.parseJwt(Auth.getToken()),
    name: '',
    avatar: '',
    isLogged: false,
    roles: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_PAYLOAD: (state, payload) => {
      state.payload = payload
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_LOGGED: (state, logged) => {
      state.isLogged = logged
    }
  },
  getters: {
    isUserLogged (state) {
      return !_.isEmpty(state.payload)
    },
    getPayload (state) {
      return state.payload
    }
  },
  actions: {
    Login ({ commit }, {token, payload}) {
      commit('SET_TOKEN', token)
      commit('SET_PAYLOAD', payload)
      commit('SET_NAME', payload.name)
      commit('SET_LOGGED', payload.name)
      Auth.checkValidity()
    },
    LoginBackend ({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(username, userInfo.password).then((response) => {
          const data = response
          Auth.saveToken(data.token)
          commit('SET_TOKEN', data.token)
          let payload = Auth.parseJwt(data.token)
          commit('SET_PAYLOAD', payload)
          commit('SET_NAME', payload.name)
          commit('SET_LOGGED', data.login)
          if (data.login) {
            resolve()
          } else {
            reject(new Error('bad login'))
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    Initialize ({ commit, state }) {
      if (state.payload && Auth.isTokenFresh(state.payload)) {
        commit('SET_LOGGED', true)
        Auth.checkValidity()
      } else {
        commit('SET_LOGGED', false)
      }
    },

    LogOut ({ commit, state }) {
      let params = {
        redirect_uri: window.location.href,
        client_id: process.env.VUE_APP_AIO_CONNECT_CLIENT_ID,
        refresh_token: Auth.getToken(),
        response_type: 'id_token',
        nonce: 'waluigithewinner'
      }
      var encodeDataToURL = Object.keys(params).map(value => `${value}=${encodeURIComponent(params[value])}`).join('&')
      return new Promise((resolve, reject) => {
        
        commit('SET_TOKEN', '')
        commit('SET_LOGGED', false)
        commit('SET_PAYLOAD', {})
        commit('SET_ROLES', [])
        resolve()

      }).then( () => {
        Auth.logout()
        window.location = process.env.VUE_APP_AIO_CONNECT_URL + 'logout?' + encodeDataToURL
      })
    },
    FedLogOut ({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        Auth.logout()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js